import sounds from "./sounds";
const gameData = [
    [
        {
            id: 1,
            name: 'Стальной алхимик',
            original: 'Fullmetal Alchemist',
            description: 'Действие сюжета происходит в стране Аместрис, где алхимия широко распространена как точная наука. Два главных героя, братья Эдвард и Альфонс Элрики, сыновья великого алхимика. Им было всего 11 и 10 лет, когда они решили, что знают об алхимии достаточно, чтобы воскресить покойную мать.',
            image: require('../images/anime/alchemist.jpg'),
            audio: sounds.anime.alchemist
        },
        {
            id: 2,
            name: 'Врата штейна',
            original: 'Steins Gate',
            description: 'Машина времени. Услышав это словосочетание, начинаешь представлять сложную и массивную конструкцию. Однако гениальный мозг самопровозглашенного ученого считает иначе. Он разработал устройство на основе обычной микроволновки, благодаря которому можно отправлять в прошлое короткие текстовые сообщения.',
            image: require('../images/anime/steins.jpg'),
            audio: sounds.anime.steins_gate
        },
        {
            id: 3,
            name: 'Необъятный океан',
            original: 'Grand Blue',
            description: 'Иори Китахара начинает свой путь в колледже у океана в городе Идзу, полный волнения за свою новую жизнь. Он переезжает в дайвинг-магазин «Grand Blue», которым владеет его дядя. Получится ли у Иори жить обычной жизнью в колледже своей мечты?',
            image: require('../images/anime/grandblue.jpg'),
            audio: sounds.anime.grand_blue
        },
        {
            id: 4,
            name: 'Бек',
            original: 'BECK: Mongolian Chop Squad',
            description: 'Танака Юкио - ученик средней школы, удрученный собственным не выдающимся существом. Но так было, пока в его мир, сам того не ведая, не ворвался Минами Рюсукэ. Он сделал то, что изменило всю жизнь Коюки, - протянул ему гитару.',
            image: require('../images/anime/beck.jpg'),
            audio: sounds.anime.beck
        },
        {
            id: 5,
            name: 'Пожиратель душ',
            original: 'Soul Eater',
            description: 'Сюжет разворачивается вокруг трёх групп Повелителей и их Орудий, которые учатся в Академии. Всем им придётся непросто, ведь помимо защиты Академии от ведьм, им придётся ещё и выполнять миссии Шинигами, чтобы вырастить из своего Орудия настоящую Косу Смерти.',
            image: require('../images/anime/souleater.jpeg'),
            audio: sounds.anime.soul_eater
        },
        {
            id: 6,
            name: 'Судьба: Ночь схватки',
            original: 'Fate Stay Night Unlimited Blade Works',
            description: 'Ученик старшей школы, Эмия Широ, невольно становится участником войны за Святой Грааль, которая проходит в японском городе Фуюки каждые 60 лет. Это борьба семерых магов за обладание легендарным артефактом — Святым Граалем, который исполнит любое желание победителя.',
            image: require('../images/anime/fate.jpg'),
            audio: sounds.anime.fate
        },
    ],
    [
        {
            id: 1,
            name: 'Настоящий детектив',
            original: 'True Detective',
            description: 'Два детектива полиции штата Луизиана Растин «Раст» Коул и Мартин «Марти» Харт расследуют таинственное убийство Доры Лэнг. Однако их попытки найти преступника растягиваются на 17 лет.',
            image: require('../images/series/true_detective.jpg'),
            audio: sounds.series.detective
        },
        {
            id: 2,
            name: 'Тайны Смолвиля',
            original: 'Smallvile',
            description: 'На небольшой тихий городок Смолвилль обрушивается метеоритный дождь, после которого семейство Кентов находит неподалеку от своего дома маленького мальчика. Бездетные Марта и Джонатан усыновляют ребенка и дают ему имя Кларк.',
            image: require('../images/series/smallville.jpg'),
            audio: sounds.series.smallvile
        },
        {
            id: 3,
            name: 'Настоящая кровь',
            original: 'True Blood',
            description: 'Действие сериала происходит в вымышленном городе Бон-Там в штате Луизиана и развивается вокруг отношений центральных персонажей: официантки с телепатическими способностями Суки Стакхаус и вампира Билла Комптона.',
            image: require('../images/series/true_blood.jpg'),
            audio: sounds.series.trueblood
        },
        {
            id: 4,
            name: 'Сверхъестественное',
            original: 'Supernatural',
            description: 'Сериал повествует о братьях — охотниках за нечистью, которые путешествуют по США на чёрной Chevrolet Impala 1967 года, расследуя паранормальные явления, многие из которых основаны на городских легендах и фольклоре, а также сражаются с порождениями зла.',
            image: require('../images/series/supernatural.jpg'),
            audio: sounds.series.supernatural
        },
        {
            id: 5,
            name: 'Теория Большого взрыва',
            original: 'The Big Bang Theory',
            description: 'У двух физиков-задротов появляется новая соседка по лестничной площадке — провинциальная блондинка Пенни, мечтающая об актерской карьере. Парни получают возможность регулярно общаться с женщиной, а Пенни учится отличать «Звездный путь» от «Звездных войн».',
            image: require('../images/series/bigbangth.jpg'),
            audio: sounds.series.bigbang
        },
        {
            id: 6,
            name: 'Дикий ангел',
            original: 'Muñeca Brava',
            description: 'Яркая романтическая история Милагрос, которая рано потеряла мать, но, тем не менее, выросла храброй и уверенной в себе девушкой. Она любит играть в футбол и одеваться по-мальчишески. Однажды она устраивается в богатый дом служанкой, где находит свою любовь и семью.',
            image: require('../images/series/angel.jpeg'),
            audio: sounds.series.angel
        },
    ],
    [
        {
            id: 1,
            name: 'Трансформеры',
            original: 'Transformers: Revenge of the Fallen',
            description: 'Фильм повествует о войне автоботов и десептиконов — разумных инопланетных роботов, способных трансформироваться в разнообразную технику. Предметом их раздора становится могущественный артефакт Великая Искра, который при неправильном использовании может принести в Галактику разрушения и смерть.',
            image: require('../images/movies/transformers.jpg'),
            audio: sounds.movies.transformers
        },
        {
            id: 2,
            name: 'Восьмая миля',
            original: '8 Mile',
            description: 'Фильм описывает жизнь молодого белого рэпера по имени Джимми «Кролик» Смит-младший, живущего во внутренней части Детройта в 1995 году, и его попытки начать карьеру рэпера, где правят бал преимущественно афроамериканцы.',
            image: require('../images/movies/mile8.jpg'),
            audio: sounds.movies.mile8
        },
        {
            id: 3,
            name: 'Пираты Карибского моря',
            original: 'Pirates of the Caribbean',
            description: 'Приключенческий фильм о пиратах, действие которого разворачивается на Карибах в первой половине XVIII века. Идея картины пришла к создателям под впечатлением от одноимённого тематического водного аттракциона в Диснейленде.',
            image: require('../images/movies/pirates.jpg'),
            audio: sounds.movies.pirates
        },
        {
            id: 4,
            name: 'Плохие парни',
            original: 'Bad boys',
            description: 'Комедийный боевик с неподражаемым актерским дуэтом. Главные герои фильма - пара полицейских из Майами (Уилл Смит и Мартин Лоуренс), берутся охранять свидетельницу Джулию Мотт (Теа Леони), за которой охотится коварный наркоторговец.',
            image: require('../images/movies/badboys.jpg'),
            audio: sounds.movies.badboys
        },
        {
            id: 5,
            name: 'Властелин колец',
            original: 'The Lord of the Rings',
            description: 'Всё началось с отливки великих колец. Три из них были отданы бессмертным эльфам, семь — пещерным гномам, а девять — королям людского рода. Но в пылающей пещере вулкана Ородруин Тёмный властелин Саурон тайно выковал ещё одно — Единое Кольцо, призванное подчинить себе все остальные.',
            image: require('../images/movies/LOTR.jpg'),
            audio: sounds.movies.lotr
        },
        {
            id: 6,
            name: 'Охотники за привидениями',
            original: 'Ghostbusters',
            description: 'Трое молодых учёных из Колумбийского университета Нью-Йорка — Игон Спенглер, Рэй Стэнц и Питер Венкман — занимаются исследованием паранормальных явлений, но особенно их интересуют привидения; они проводят многочисленные исследования в области потустороннего мира.',
            image: require('../images/movies/ghostbusters.jpg'),
            audio: sounds.movies.ghostbusters
        },
    ],
    [
        {
            id: 1,
            name: 'Утиные истории',
            original: 'DuckTales',
            description: 'В центре сюжета оказывается миллиардер Скрудж Макдак и трое его внучатых племянников — Билли, Вилли и Дилли. Раньше о них заботился их дядя Дональд Дак — племянник Скруджа — однако он отправляется на военно-морской флот и временно передаёт опеку над мальчиками Скруджу.',
            image: require('../images/cartoons/ducktales.jpg'),
            audio: sounds.cartoons.duck_tales
        },
        {
            id: 2,
            name: 'Черепашки-ниндзя',
            original: 'Teenage Mutant Ninja Turtles',
            description: 'На улицах Нью-Йорка растёт подростковая преступность. Телеведущая новостей Эйприл О’Нил во время съёмок наткнулась на панков, которые захотели её убить. Она прыгнула в канализацию, панки понеслись за ней, но Эйприл выжила благодаря четырём странным существам.',
            image: require('../images/cartoons/tmnt.jpg'),
            audio: sounds.cartoons.tmnt
        },
        {
            id: 3,
            name: 'Мулан',
            original: 'Mulan',
            description: 'Когда через Великую Китайскую стену прорывается полчище Северных захватчиков, мятежная девушка Мулан тайно поступает в армию Императора под видом юноши. Она всего лишь хочет заменить на службе своего больного отца и даже не предполагает, что ей суждено стать спасительницей Китая.',
            image: require('../images/cartoons/mulan.jpg'),
            audio: sounds.cartoons.mulan
        },
        {
            id: 4,
            name: 'Аладдин',
            original: 'Aladdin',
            description: 'Мультсериал повествует о приключениях Аладдина и его друзей в Аграбе и за её пределами, о противостоянии героев силам Зла. В основном, события происходят в родном городе персонажей, аравийском городе Аграба, расположенном посреди пустыни.',
            image: require('../images/cartoons/alladin.jpg'),
            audio: sounds.cartoons.alladin
        },
        {
            id: 5,
            name: 'Холодное сердце',
            original: 'Frozen',
            description: 'Когда древнее предсказание сбывается и королевство погружается в объятия вечной зимы, трое бесстрашных героев отправляются в горы, чтобы найти сестру Анны, Эльзу, которая может снять со страны леденящее заклятие. По пути их ждет множество захватывающих приключений.',
            image: require('../images/cartoons/frozen.jpg'),
            audio: sounds.cartoons.frozen
        },
        {
            id: 6,
            name: 'Чип и Дейл спешат на помощь',
            original: "Chip 'n Dale's Rescue Rangers",
            description: 'В центре сюжета - приключения двух веселых бурундуков Чипа и Дейла, а также их друзей, которые вместе организуют «Команду Спасателей». Вместе они противостоят влиятельному коту Толстосуму, который раз за разом придумывает очередные злодейские планы.',
            image: require('../images/cartoons/rescue_rangers.jpg'),
            audio: sounds.cartoons.chip_and_dale
        },
    ],
    [
        {
            id: 1,
            name: 'В мире животных',
            original: 'In the World of Animals',
            description: '«В мире животных» — советская и российская передача, посвященная зоологии. Ее ведущий Николай Дроздов не только рассказывает о животных как доктор биологических наук, но и старается делать материал доступным и наглядным для зрителя.',
            image: require('../images/tvshows/animal_world.jpg'),
            audio: sounds.tv_shows.animalworld
        },
        {
            id: 2,
            name: 'Форт боярд',
            original: 'Fort Boyard',
            description: '«Форт Боярд» - Крепость середины XIX века, расположенная у берегов Франции. Это телеигра, в которой команде участников необходимо выдержать различные физические и интеллектуальные испытания, чтобы, выигрывая ключи и подсказки, заполучить сокровища форта.',
            image: require('../images/tvshows/fortboyard.jpg'),
            audio: sounds.tv_shows.fort
        },
        {
            id: 3,
            name: 'Зов джунглей',
            original: 'Call of the Jungles',
            description: '«Зов джунглей» — развлекательная программа для детей. Ребята делятся на две команды («Хищники» и «Травоядные») и соревнуются между собой. Задания в игре самые разные: задачки на смекалку, полоса препятствий, которую нужно пройти с закрытыми глазами, и т. д.',
            image: require('../images/tvshows/call_jungles.jpg'),
            audio: sounds.tv_shows.jungle
        },
        {
            id: 4,
            name: 'Тачку на прокачку',
            original: 'Pimp My Ride',
            description: 'В каждом выпуске команде автомехаников и автодизайнеров предстоит отремонтировать и радикально улучшить автомобиль, находящийся в плохом состоянии, но способный ездить. Исходя из вкусов обладателя автомобиля, машина подвергается дорогому, но не всегда практичному «прокачиванию».',
            image: require('../images/tvshows/pimpmyride.jpg'),
            audio: sounds.tv_shows.pimpmyride
        },
        {
            id: 5,
            name: 'Сам себе режиссёр',
            original: 'Director for Oneself',
            description: 'Программа "Сам себе режиссер" – это развлекательное шоу, в основе которого лежит демонстрация любительского видео. Оригинальное озвучивание каждого сюжета, осуществляемое группой профессиональных актеров, – главное и принципиальное отличие от зарубежных аналогов.',
            image: require('../images/tvshows/selfdirector.jpg'),
            audio: sounds.tv_shows.director
        },
        {
            id: 6,
            name: 'X-Фактор',
            original: 'X-Factor',
            description: 'The X Factor — британское телевизионное музыкальное шоу талантов. Основной целью которого является поиск и развитие песенного таланта конкурсантов. Все конкурсанты выбираются путём публичных прослушиваний.',
            image: require('../images/tvshows/xfactor.jpg'),
            audio: sounds.tv_shows.xfactor
        },
    ],
    [
        {
            id: 1,
            name: 'Морровинд',
            original: 'The Elder Scrolls III: Morrowind',
            description: 'Морровинд — это история об ещё одном никому не известном герое. Он был рождён в определённый день от неизвестных родителей, а потому, возможно, следуя пророчеству, являлся тем самым воплощением легендарного предводителя данмеров — Неревара Индорила.',
            image: require('../images/games/morrowind_logo.png'),
            audio: sounds.games.morrowind
        },
        {
            id: 2,
            name: 'Андертейл',
            original: 'Undertale',
            description: 'Ролевая игра, выполненная в пиксельной графике. Герой провалился в подземный мир. Его главная задача — исследовать мир монстров, познакомиться с его жителями и найти выход из этого подземелья.',
            image: require('../images/games/undertale.png'),
            audio: sounds.games.undertale
        },
        {
            id: 3,
            name: 'Кредо убийцы 2',
            original: "Assassin's Creed II",
            description: 'Действие игры происходит в средние века в Италии. Современный потомок величайших убийц в истории Дезмонд оказывается в теле Эцио Аудиторе де ла Фиренце, мастерски владеющего хашшашинскими навыками.',
            image: require('../images/games/ac2.jpg'),
            audio: sounds.games.ac2
        },
        {
            id: 4,
            name: 'Фоллаут 4',
            original: 'Fallout 4',
            description: 'Протагонист – единственный выживший из убежища 111, оказавшийся в мире, разрушенном ядерной войной. Каждый миг он сражается за выживание, каждое решение может стать последним. Но именно от него зависит судьба пустошей.',
            image: require('../images/games/fallout.jpg'),
            audio: sounds.games.fallout4
        },
        {
            id: 5,
            name: 'Батлфилд',
            original: 'Battlefield',
            description: 'Серия компьютерных игр в жанре тактико-стратегического шутера от первого лица. Серия особо популярна своим многопользовательским режимом с выбором воюющей стороны, класса бойца с уникальным оружием, и возможностью управлять техникой на земле, на воде и в небе.',
            image: require('../images/games/battlefield.jpg'),
            audio: sounds.games.battlefield
        },
        {
            id: 6,
            name: 'Божественность: Первородный грех II',
            original: 'Divinity: Original Sin II',
            description: 'Пустота надвигается со всех сторон. И виноваты в этом колдуны Истока. Магистры Божественного Ордена стремятся избавить Ривеллон от угрозы со стороны колдунов… подобных вам. Вы схвачены и отправлены в форт «Радость», где вам предстоит «излечиться» от своего «недуга».',
            image: require('../images/games/divinity2.jpg'),
            audio: sounds.games.divinity
        },
    ],
]

export default gameData;